import { render, staticRenderFns } from "./AdAddPage.vue?vue&type=template&id=19764e62&scoped=true&"
import script from "./AdAddPage.vue?vue&type=script&lang=js&"
export * from "./AdAddPage.vue?vue&type=script&lang=js&"
import style0 from "./AdAddPage.vue?vue&type=style&index=0&id=19764e62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19764e62",
  null
  
)

export default component.exports